'use strict';

export default function isTypeOrNull(value: unknown, valueType: string): boolean {
    const isNull = value === null;
    const isOfExpectedType = valueType === 'Array' ? Array.isArray(value) : typeof value === valueType;

    return isOfExpectedType || isNull;
}
